import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteType,
  getTypes,
} from "../../../redux/features/categoryAndType/categoryAndTypeSlice";
import { FaTrashAlt } from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const TypeList = () => {
  const { isLoading, types } = useSelector((state) => state.category);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTypes());
  }, [dispatch]);

  const confirmDelete = (slug) => {
    confirmAlert({
      title: "Delete Post Type",
      message: "Are you sure to delete?.",
      buttons: [
        {
          label: "Delete",
          onClick: () => delType(slug),
        },
        {
          label: "Cancel",
          //  onClick: () => alert("Click No"),
        },
      ],
    });
  };

  const delType = async (slug) => {
    await dispatch(deleteType(slug));
    await dispatch(getTypes());
  };

  return (
    <div className="--mb2">
      <h3>Post Types</h3>
      <div className="table">
        {types.length === 0 ? (
          <p>No Type Found</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>s/n</th>
                <th>Name</th>
                <th>Category</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {types.map((type, index) => {
                const { _id, name, slug, category } = type;
                return (
                  <tr key={_id}>
                    <td>{index + 1}</td>
                    <td>{name}</td>
                    <td>{category}</td>
                    <td>
                      <span>
                        <FaTrashAlt
                          size={20}
                          color={"red"}
                          onClick={() => confirmDelete(slug)}
                        />
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
export default TypeList;
